/** @jsx isolateComponent */
import { css } from '@emotion/core';
import React from 'react';

import { ColorName, Colors } from '@zapier/design-system';
import { SizeType } from '@zapier/product-get-help/src/types';
import { isolateComponent } from '@zapier/style-encapsulation';
import Container from '../Container';

type BackgroundSectionProps = {
  /** Set the tint for the background color. Defaults to light */
  tint?: 'light' | 'dark';
  //** Background color override */
  backgroundColor?: ColorName;
  /** Size to display. */
  size?: SizeType;
  //** Padding Top in pixels for the container */
  containerPaddingTop?: number;
  //** Padding Bottom in pixels for the container */
  containerPaddingBottom?: number;
  /** Children to render */
  children: React.ReactNode;

  height?: string;
};

const BackgroundSectionCss = (color: ColorName, height: string) => css`
  background-color: ${Colors[color]};
  height: ${height};
  flex: 1;
`;

/**
 * A component to create a section of background with a specific color and a container.
 */
const BackgroundSection = ({
  children,
  tint = 'light',
  size = 'large',
  height = 'auto',
  backgroundColor,
  containerPaddingTop = 0,
  containerPaddingBottom = 0,
}: BackgroundSectionProps) => {
  const color = backgroundColor
    ? backgroundColor
    : tint === 'light'
    ? 'neutral100'
    : 'cream';

  return (
    <section css={BackgroundSectionCss(color, height)}>
      <Container
        paddingBottom={containerPaddingBottom}
        paddingTop={containerPaddingTop}
        size={size}
      >
        {children}
      </Container>
    </section>
  );
};

export default BackgroundSection;
